/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';
import { getEventSupportEmail } from '@e180/domain/lib/event/util';

import SupportSentNotificationDumb from './SupportSentNotificationDumb';
import { supportEmail } from 'src/shared/app/base/settings/contactSettings';
import { dismissNotification } from 'src/shared/app/notification/action/uiNotificationActions';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';

import type { Notification } from 'src/shared/app/notification/type/notificationTypes';

type Props = {
  notification: Notification,
};

const mapStateToProps = (state: Object): Object => {
  const event = getEventSafely(state);

  return {
    ...state,
    supportEmail: getEventSupportEmail(event) || supportEmail,
  };
};

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (
  stateProps: Object,
  { dispatch }: Object,
  { notification }: Props,
): Object => ({
  ...stateProps,
  handleDismiss() {
    dispatch(dismissNotification(notification));
  },
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(SupportSentNotificationDumb);
